import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { WAKEUP_FORM_DATA } from '../../common/common.constatns';

import { axiosCustom } from '../../common/common.function';
import { IScrapProdProps } from '../../common/interface/props';
import { RootState } from '../../redux_modules';

export function ScrapProdForm({ solType, targetSolType }: IScrapProdProps) {
  const navigate = useNavigate();
  const { shopInfo, wakeupInfo } = useSelector((state: RootState) => ({
    shopInfo: state.shopLogin,
    wakeupInfo: state.wakeupLogin,
  }));
  const shopNames1 = targetSolType.map((shop) => WAKEUP_FORM_DATA[shop].name.type1);
  const shopNames4 = targetSolType.map((shop) => WAKEUP_FORM_DATA[shop].name.type4);

  const html =
    solType === 'ALL'
      ? `<div class="textArea">
        <div class="primaryText">
        [${shopNames1.join(',&nbsp&nbsp')}]<br/> <p class="colorText">상품 등록 작업이 시작되었습니다.</p>
        </div>
        ※ 안내<br/>
        작업은 상품 등록 개수에 따라 최대 약 1일이 소요 될 수 있습니다.
        <p class="colorText">작업 완료 후에 회원 가입 시 입력한 이메일로 작업 결과를 전송해드립니다.</p>
        </div>
        `
      : `<div class="textArea">
            <div class="primaryText">
            ${shopNames4[0]}<br/> <p class="colorText">상품 등록 작업이 시작되었습니다.</p>
            </div>
            <br/><br/>
            ※ 안내<br/>
            작업은 상품 등록 개수에 따라 최대 약 1일이 소요되며, 진행 현황은 <br/>
            아래 확인 버튼을 클릭하여 확인하실 수 있습니다.
            <p class="colorText">(진행 현황 페이지의 URL을 회원 가입 시 입력한 이메일로도 전송해드립니다.)</p>
            </div>
            `;

  /**
   * 상품 이전 작업 시작 안내 문구 노출
   */
  const showGuide = async () => {
    await Swal.fire({
      customClass: {
        popup: 'swal-custom-popup',
        header: 'swal-custom-header',
        title: 'swal-custom-title',
        content: 'swal-custom-content',
        actions: 'swal-custom-actions',
        confirmButton: 'swal-custom-confirmButton',
        cancelButton: 'swal-custom-cancleBtn',
      },
      title: `${shopNames1.join(',')} 상품등록`,
      html,
      confirmButtonText: '확인',
      width: 600,
      allowOutsideClick: false,
      showCloseButton: false,
      showCancelButton: false,
    });
  };

  useEffect(() => {
    async function fetchData() {
      // 쇼핑몰, WakeUp 데이터 유효성 검사
      if (shopInfo.status === 'SUCCESS' && wakeupInfo.status === 'SUCCESS') {
        Swal.fire({
          title: `잠시만 기다려 주세요...`,
          html: '작업 생성 중...',
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });

        // 동기처리 위해서 for 씀
        for (const shop of targetSolType) {
          // 수집 할 쇼핑몰 / WakeUp 모델 데이터 합치기
          const jobInputData = {
            ...shopInfo.data.shopInfo,
            prodCodes: wakeupInfo.data[shop].wakeupInfo.prodCodes,
            scrapType: wakeupInfo.data[shop].wakeupInfo.scrapType,
            wakeupId: wakeupInfo.data[shop].wakeupInfo.scrapShopId,
            wakeupPw: wakeupInfo.data[shop].wakeupInfo.scrapShopPw,
            wakeupEtc1: wakeupInfo.data[shop].wakeupInfo.scrapShopEtc1,
            wakeupEtc2: wakeupInfo.data[shop].wakeupInfo.scrapShopEtc2,
            wakeupEtc3: wakeupInfo.data[shop].wakeupInfo.scrapShopEtc3,
            wakeupEtc4: wakeupInfo.data[shop].wakeupInfo.scrapShopEtc4,
            wakeupEtc5: wakeupInfo.data[shop].wakeupInfo.scrapShopEtc5,
            wakeupEtc6: wakeupInfo.data[shop].wakeupInfo.scrapShopEtc6,
            wakeupDummy3: wakeupInfo.data[shop].wakeupInfo.shopDummy3,
            coupangSellerType: wakeupInfo.data[shop].wakeupInfo.coupangSellerType,
            targetSolType: wakeupInfo.data[shop].wakeupInfo.targetSolType,
          };

          // 상품 수집 실행
          const jobId = await scrapProdSend(jobInputData);

          // jobid가 없으면서 all 이아니면 보내버림
          if (!jobId && solType !== 'ALL') {
            window.location.href = `/${shop.toLowerCase()}/job/shop-login`;
            return true;
          }

          // all 이 아니면서 여기까지 왔으면 성공한거라 프로그레스바 페이지로 이동 하고 끝냄
          // 루프안에 있는 이유는 jobId가 필요하기 때문
          if (solType !== 'ALL') {
            // 위에서 jobId 가 생성 된 후 상품 이전 작업 시작 swal 노출
            await showGuide();

            window.location.href = `/${solType.toLowerCase()}/job/${jobId}`;
            return true;
          }
        }

        if (solType === 'ALL') {
          // 위에서 jobId 가 생성 된 후 상품 이전 작업 시작 swal 노출
          await showGuide();

          // ALL 타입 작업 모두 걸고나면 사이트 선택  페이지로 이동
          // 루프 밖에 있는 이유는 쇼핑몰 전체 작업 다 끝내고 페이지 이동 시켜야 하니까
          window.location.href = `/${solType.toLowerCase()}/job/shop-login`;
          return true;
        }
      } else {
        // 유효성 검사 실패 또는 작업 모두 걸고 나서 shop-login으로 이동
        window.location.href = `/${solType.toLowerCase()}/job/shop-login`;
        return true;
      }

      // 상품수집 작업 시작
      async function scrapProdSend(jobInputData: any) {
        try {
          //상품수집 작업 시작
          const temp = await axiosCustom.post(`${process.env.REACT_APP_BACKEND_ENDPOINT}/api/job/scrap-prod`, jobInputData);

          return temp.jobId;
        } catch (error: any) {
          await Swal.fire({
            title: '실패',
            html: error.message,
            icon: 'error',
            confirmButtonText: '확인',
          });

          return false;
        }
      }
    }

    fetchData();
  }, [navigate, solType, shopInfo, wakeupInfo]);

  return <></>;
}
